module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-3200.76a29e90.svg";